module.exports = __webpack_public_path__ + "inputs/img/banner.b81b58bf.png";